import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";


const RoleManagement = createApi({
  reducerPath:"RoleManagement",
  baseQuery:customFetchBase,
  endpoints:(builder)=>({
    
    addRole:builder.mutation({
      query:(data)=>({
          url:`/Roles/AddRole`,
          method:'POST',
          body:transformRequest(data)
      }),
      transformResponse:transformSuccessResponse,
      transformErrorResponse:transformErrorResponse,
  }),

  getRoleList:builder.query({
      query: () => ({
          url: `Roles/GetAllRoles`,
          method: 'GET',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
  }),

  DeleteRole:builder.mutation({
      query: (data) => ({
          url: `/Roles/DeleteRole?id=${data}`,
          method: 'DELETE',
          body: transformRequest(data)
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
  }),
  getRoleById:builder.query({
      query: (roleId) => ({
          url: `/Roles/GetRoleById?roleId=${Number(roleId)}`,
          method: 'GET',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
  }),
  updateRole:builder.mutation({
      query: (data) => ({
          url: `/Roles/UpdateRoleByRoleId`,
          method: 'POST',
          body: transformRequest(data),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
  }),

  getRoles: builder.mutation({
    query: (userQuery) => ({
        url: `/Roles/GetAllRolesWithPagination`,
        method: 'POST',
        body: transformRequest(userQuery)
    }),
    transformResponse: transformSuccessResponse,
    transformErrorResponse: transformErrorResponse,
}),

getUnAssignedUserByRoleId:builder.query({
    query: (roleId) => ({
        url: `/Roles/GetUnAssignedUserByRoleId?roleId=${Number(roleId)}`,
        method: 'GET',
    }),
    transformResponse: transformSuccessResponse,
    transformErrorResponse: transformErrorResponse,
}),
addRoleMapping:builder.mutation({
    query: (data) => ({
        url: `/Security/AddRoleMapping`,
        method: 'POST',
        body: transformRequest(data),
    }),
    transformResponse: transformSuccessResponse,
    transformErrorResponse: transformErrorResponse,
}),
getRolesMappingByRoleId: builder.mutation({
    query: (userQuery) => ({

        url: '/Security/GetRolesMappingByRoleId',
        method: 'POST',
        body: transformRequest(userQuery)
    }),
    transformResponse: transformSuccessResponse,
    transformErrorResponse: transformErrorResponse
}),
deleteRolesMapping: builder.mutation({
    query: (userId) => ({
        url: encryptQueryString(`/Security/DeleteRolesMapping/?userRoleId=${userId}`),
        method: 'DELETE',
        body: transformRequest(userId)
    }),
    transformResponse: transformSuccessResponse,
    transformErrorResponse: transformErrorResponse
}),
  }),

})

export const { useAddRoleMutation,
   useLazyGetRoleListQuery,
   useDeleteRoleMutation,
   useLazyGetRoleByIdQuery,
   useUpdateRoleMutation,
   useGetRolesMutation,
   useLazyGetUnAssignedUserByRoleIdQuery,
   useAddRoleMappingMutation,
   useGetRolesMappingByRoleIdMutation,
   useDeleteRolesMappingMutation,
} =RoleManagement;

export default RoleManagement;